import axios from 'axios';
import { BASE_URL } from 'constants/index';

export const SIGN_UP = async (e) => {
  const res = await axios.post(BASE_URL + `/account/signup`, e);
  return res.data;
};
